import useIsomorphicLayoutEffect from 'mk2/hooks/useIsomorphicLayoutEffect';
import { useCallback, useRef } from 'react';

type EventCallback = (...args: any[]) => void;

function useEventCallback(fn, dependencies) {
    const ref = useRef<EventCallback>(() => {
        throw new Error('Cannot call an event handler during rendering.');
    });

    useIsomorphicLayoutEffect(() => {
        ref.current = fn;
    }, [fn, ...dependencies]);

    return useCallback((...args) => {
        return ref.current(...args);
    }, [ref]);
}

export default useEventCallback;
